import { atom, useStateXAtom } from '@cloudio-saas/statex';
import { ItemType } from 'componentregistry';
import { RefObject, useEffect, useRef } from 'react';

export const focusItemIdAtom = atom({
  path: ['transient', '$focusItemId'],
  defaultValue: '',
});

export const FocusableItems = [
  'ControllerComponent',
  'InputBase',
  'LOVColumn',
  'LOVField',
  'LookupSelect',
  'NumberField',
  'SearchDateField',
  'SearchLookupField',
  'SearchNumberField',
  'SearchSelectField',
  'SearchTextField',
  'Select',
  'AsyncSelect',
  'TextField',
  'SimpleFilter',
  'SmartSearch',
  'MutliSelectLOVField',
  'DateColumn',
  'NumberColumn',
  'StringColumn',
  'SelectColumn',
  'SwitchColumn',
  'AsyncSelectColumn',
] as ItemType[];

export function useFocus(itemId: string): RefObject<HTMLInputElement> {
  const ref = useRef<HTMLInputElement>(null);
  const [focusItemId, setFocusItemId] = useStateXAtom(focusItemIdAtom);
  useEffect(() => {
    if (focusItemId === itemId && ref.current) {
      const timer = setTimeout(() => {
        ref.current?.focus();
        setFocusItemId('');
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [focusItemId, itemId, setFocusItemId]);
  return ref;
}
